export default __webpack_public_path__ + "static/media/loading.c344c7cf.gif";